let editorOriginType = ''

export function setEditorOriginType(editorType) {
  editorOriginType = editorType
}

export function getEditorOriginType() {
  return editorOriginType
}
